import { render, staticRenderFns } from "./sliderItem.vue?vue&type=template&id=70cb4130"
import script from "./sliderItem.vue?vue&type=script&lang=js"
export * from "./sliderItem.vue?vue&type=script&lang=js"
import style0 from "./sliderItem.vue?vue&type=style&index=0&id=70cb4130&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports